"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const React = require("react");
const BaseInput_1 = require("../BaseInput");
const KeypadWrapper_1 = require("../../atoms/KeypadWrapper");
class TextInput extends BaseInput_1.BaseInput {
    render() {
        const { value, placeholder = "", allowNewlines = false, disabled = false, keypadOptions = null, hint, className } = this.props;
        const getInput = () => {
            if (allowNewlines) {
                return (React.createElement("textarea", { "data-test": "input", "data-hint": hint, onChange: evt => {
                        this.onInputChange(evt.target.value);
                    }, onBlur: evt => {
                        this.onInputChange(evt.target.value.trim());
                    }, value: value || "", placeholder: placeholder, disabled: disabled, "data-input-type": "textarea", className: className }));
            }
            else {
                return (React.createElement("input", { "data-test": "input", "data-hint": hint, type: "text", onChange: evt => {
                        this.onInputChange(evt.target.value);
                    }, onBlur: evt => {
                        this.onInputChange(evt.target.value.trim());
                    }, value: value || "", placeholder: placeholder, disabled: disabled, "data-input-type": "singleLine", className: className }));
            }
        };
        const input = getInput();
        return keypadOptions ? (React.createElement(KeypadWrapper_1.KeypadWrapper, { inputComponent: input, keypadOptions: keypadOptions })) : (input);
    }
}
exports.TextInput = TextInput;
//# sourceMappingURL=index.js.map